import { useRouteLoaderData } from 'react-router';

import type { EmbedSearchWidgetApiMetadata } from '#/modules/embedSearchWidget/api/types/EmbedSearchWidgetApiMetadata';

export function useEmbedSearchWidgetLayoutRouteLoaderData() {
  const loaderData = useRouteLoaderData<{
    embedSearchWidget: EmbedSearchWidgetApiMetadata;
  }>('embed-search-widget-layout');

  const { embedSearchWidget } = loaderData ?? {};

  return {
    embedSearchWidgetSearchRadius: embedSearchWidget?.radius,
    embedSearchWidgetSearchLocation: embedSearchWidget?.location,
  };
}
